import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { openNotification } from 'src/components/helpers/notification';
import ax from 'src/store/config';


const initialState = {
    trainingRecordsList: null,
    trainingRecordsLoading: false
};

export const trainingRecordsAction = createAsyncThunk('trainingRecordsAction', async (payload, { dispatch }) => {
    dispatch(setTrainingRecordsLoading(true))
    try {
        let data;
        const url = '/api/admin/directory/userTrainingRecords';
        switch (payload.flag) {
            case 'get':
                ({ data } = await ax.get(url, { params: payload.value }))
                data && dispatch(setTrainingRecordsLoading(false))
                return data
            default:
                break;
        }
    } catch (error) {
        dispatch(setTrainingRecordsLoading(false))
        openNotification({
            type: 'error',
            message: `Ошибка ${error.response.data.errorMessages[0].errorCode}. ${error.response.data.errorMessages[0].errorMessage}`
        })
        return error
    }
})

const TrainingRecordsSlice = createSlice({
    name: 'trainingRecords',
    initialState,
    reducers: {
        setTrainingRecordsLoading: (state, action) => {
            state.setTrainingRecordsLoading = action.payload
        }
    },
    extraReducers: (builder) => {
        builder.addCase(trainingRecordsAction.fulfilled, (state, action) => {
            state.trainingRecordsList = action.payload
        })
    }
});

export const { setTrainingRecordsLoading } = TrainingRecordsSlice.actions;

export default TrainingRecordsSlice.reducer